import React from 'react';
import SwaggerUIComponent from '../components/SwaggerUIComponent';

const SwaggerPage = () => {
  return (
    <div className="swagger-page">
      <SwaggerUIComponent />
    </div>
  );
};

export default SwaggerPage;
